import { Typography } from '@mui/material';
import React from 'react';

import { Link } from '@sbu/components.link';
import { UserPrivilege } from '@sbu/hooks.userprivileges';
import { Tab, Tabs } from '@sumologic/yama-ds-components';

import { UserPrivilege as LegacyPrivilege } from 'core/graphql';

export interface Page {
  route: string;
  label: string;
  value: string;
  requiredPrivileges: [UserPrivilege, LegacyPrivilege];
}

export interface ConfigPageHeaderProps {
  title: string;
  currentPage: string;
  pages: Page[];
}

export const ConfigPageHeader = ({
  title,
  currentPage,
  pages,
}: ConfigPageHeaderProps) => {
  return (
    <>
      <Typography variant='h1' mb={2} data-sumo-test='config-page-header-title'>
        {title}
      </Typography>
      <Tabs value={currentPage}>
        {pages?.map(({ route, label, value }: Page) => (
          <Tab
            key={value}
            href={route}
            label={label}
            value={value}
            LinkComponent={Link}
          />
        ))}
      </Tabs>
    </>
  );
};

export default ConfigPageHeader;
